"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPurposes = void 0;
const get_zaraz_1 = require("../helpers/get-zaraz");
/**
 * An object containing all configured purposes, with their ID, name, description, and order.
 */
function getPurposes() {
    return (0, get_zaraz_1.getZaraz)().consent.purposes;
}
exports.getPurposes = getPurposes;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0LXB1cnBvc2VzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2NvbnNlbnQvZ2V0LXB1cnBvc2VzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLG9EQUFnRDtBQVFoRDs7R0FFRztBQUNILFNBQWdCLFdBQVc7SUFDekIsT0FBTyxJQUFBLG9CQUFRLEdBQUUsQ0FBQyxPQUFPLENBQUMsUUFBUSxDQUFDO0FBQ3JDLENBQUM7QUFGRCxrQ0FFQyJ9